const calculatedNewPrice = (price, rejustment) => {
  const priceFloat = parseFloat(price)
  let newPrice =
    priceFloat + (priceFloat * parseFloat(rejustment).toFixed(2)) / 100

  return newPrice?.toFixed(2)
}
export default calculatedNewPrice
